import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Pagamento } from "../../../../services/Pagamento";

export const useConsultarFatura = (uuidAgendamento: string) => {
  const query = useQuery({
    queryKey: ["consultar-fatura", uuidAgendamento],
    queryFn: () => Pagamento.consultarFatura({ uuidAgendamento }),
    select: (response) => response.data,
    enabled: !!uuidAgendamento,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
